import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { socket } from "./socket"

export const useWorkspaceWebSocket = ({
  connect = false,
  jobChunkProcessedCallback = () => {},
  jobProcessingEndedCallback = () => {}
}) => {
  const dispatch = useDispatch()
  const auth = useSelector((state) => state.auth)

  const registerListeners = async (socket) => {
    socket.on("job-chunk-received", (data) => {
      jobChunkProcessedCallback(data);
    })

    socket.on("job-processing-ended", (data) => {
      jobProcessingEndedCallback(data);
    });

    socket.on("message", (text) => console.log(text))
  }

  useEffect(() => {
    const webSocket = socket(auth?.token);

    if (connect) {
      webSocket.connect()
      registerListeners(webSocket);
    } else {
      webSocket.disconnect()
    }

    return () => {
      webSocket.disconnect()
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.token, dispatch, connect,])
}
